import { useRouter } from 'next/router'

import type { Dictionary } from './dictionaries/en'
import type { Locale } from './config'

import { en } from './dictionaries/en'
import { de } from './dictionaries/de'
import { fr } from './dictionaries/fr'
import { defaultLocale, locales } from './config'

const dictionaries: Record<Locale, Dictionary> = { en, de, fr }

export function getDictionary(locale?: string): Dictionary {
    if (locale && (locales as readonly string[]).includes(locale)) {
        return dictionaries[locale as Locale]
    }

    return dictionaries[defaultLocale]
}

export function useLocale(): Locale {
    const { locale } = useRouter()

    return (locale as Locale) ?? defaultLocale
}

export function useTranslation(): { t: Dictionary; locale: Locale } {
    const locale = useLocale()

    return { t: getDictionary(locale), locale }
}

export type { Dictionary, Locale }
export { defaultLocale, locales }
